import styled from 'styled-components';
import { font } from 'styles/globals';
import CustomLink from 'components/Globals/Base/Link';
import Heading from 'styles/typography/Heading';
import { bluePrimaryLink } from 'components/Globals/Base/Link/LinkStyles';
import { Theme, getColor } from 'styles/theme';
import { arrowDown } from 'styles/icons';

export const MenuWrapper = styled.li`
  width: 100%;
`;

export const Arrow = styled.span<{ theme: Theme }>`
  ${arrowDown}
  padding: 4px;
`;

export const MenuHeader = styled.span<{ theme: Theme }>`
  width: 100%;
  display: flex;    
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${getColor('textPrimary')};
  gap: 8px;
  padding-right: 8px;
  cursor: pointer;
  &.up {
    .arrow {
      transform: rotate(-135deg);
    }
  }
`;

export const MenuTitle = styled(Heading)`
  margin-bottom: 8px;
`;

export const MenuContent = styled.ul<{ $open: boolean }>`
  flex-wrap: wrap;
  gap: 16px;
  ${({ $open }) => `
    margin-bottom: ${$open ? '32px' : '0'};
    display: ${$open ? 'flex' : 'none'};
  `}

  & > li:first-child {
    padding-top: 24px;
  }
`;

export const Submenu = styled.li.attrs({ 'aria-level': 4, role: 'heading' })`
  width: 100%;
`;

export const SubmenuTitle = styled(CustomLink)<{ theme: Theme }>`
  ${bluePrimaryLink};
  font-family: ${font.graphikCond};
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 0.2px;
  line-height: 24px;
`;
